<template>
    <div class="modal fade " ref="draftOrderModel" id="draftOrderModel">
      <div class="modal-dialog">
        <div class="modal-content" style="width: 1200px">
  
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title w-100">טיוטות</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
  
          <!-- Modal body -->
          <div v-if="isLoader">
            <loader />
          </div>
          <div v-else class="modal-body">
            <!-- תוצאות -->
            <div v-if="showResults && insuranceResults || errorMessage" class="row mb-4">
              <div class="col-12">
                <h5 class="mb-3">תוצאות הצעות מחיר</h5>
                <div v-if="errorMessage">
                  <p>{{ errorMessage }}</p>
                </div>
                <ul v-else class="list-group">
                  <li 
                    v-for="(value, key) in insuranceResults" 
                    :key="key"
                    class="list-group-item"
                  >
                    <strong>{{ key }}:</strong> {{ value }}
                  </li>
                </ul>
                <button class="btn btn-secondary mt-3" @click="resetResults()">חזור לבחירת חברה</button>
              </div>
            </div>
            
            <!-- בחירת חברה -->
            <div v-else class="row">
              <div class="col-12">
                <h5 class="mb-3">בחר חברת ביטוח ליצירת טיוטה</h5>
                <div class="list-group">
                  <div 
                    v-for="(company, index) in insuranceCompanies" 
                    :key="index"
                    class="list-group-item d-flex justify-content-between align-items-center"
                    style="cursor: pointer;"
                    @click="createDraft(company)"
                  >
                    <span class="font-weight-bold">{{ company.name }}</span>
                    <i class="fa fa-plus-circle text-primary"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "@/axios";
  import Multiselect from "vue-multiselect";
  import { updateStatusNew } from '@/utils/utilsFunctions.js';
  
  import loader from '@/components/loader'
  
  export default {
  
    components: {Multiselect,  loader},
    name: 'DraftOrderModel',
    props: {
      baseInfo: Object,
    },
  
    data() {

      return {
        statusId: '',
        hideBtn: false,
        countOfResultStatus: 0,
        isLoader: false,
        insuranceCompanies: [
          { name: 'הראל', draftsCount: 0, drafts: [] },
          { name: 'שלמה', draftsCount: 0, drafts: [] },
          { name: 'מנורה', draftsCount: 0, drafts: [] },
          { name: 'כלל', draftsCount: 0, drafts: [] }
        ],
        insuranceResults: null,
        showResults: false
      }

    },
  
    created() {
  
    },
    methods: {
       
        async createDraft(company) {
          try {
            this.isLoader = true;
            
            // יצירת שם החברה ל-URL (המרה לאנגלית)
            const companyUrl = this.getCompanyUrl(company.name);
            
            // יצירת טיוטה חדשה
            // הסרת add-info מה-baseInfo
            const cleanBaseInfo = { ...this.baseInfo };
            delete cleanBaseInfo['add-info'];
            
            const response = await axios.post(`/insuranceCompanies/getInsuracnceDraft`, {
              company: companyUrl, // "harel", "shlomo", etc.
              companyName: company.name, // "הראל", "שלמה", etc.
              modeSource: this.$store.getters.currentModeSource || 'hova',
              baseInfo: cleanBaseInfo
            });
            
            console.log(response.data.data.insuranceCompanies.returnMessage);
            
            // שמירת התוצאות והפעלת toggle
            if (response.data && response.data.data && response.data.data.insuranceCompanies) {
              this.insuranceResults = response.data.data.insuranceCompanies.responseOfOffer;
              this.showResults = true; // הפעלת ה-CARD
            }

            if(response.data && response.data.data &&response.data.data.insuranceCompanies.returnMessage) {
              this.errorMessage = response.data.data.insuranceCompanies.returnMessage;
              this.showResults = true;
            }
            
          } catch (error) {
            console.error(`שגיאה ביצירת טיוטה עבור ${company.name}:`, error);
            
            let errorMessage = `שגיאה ביצירת טיוטה עבור ${company.name}`;
            
            if (error.code === 'ERR_NETWORK') {
              errorMessage = 'בעיית רשת - בדוק את החיבור לאינטרנט';
            } else if (error.response) {
              errorMessage = `שגיאת שרת: ${error.response.status}`;
            } else if (error.message) {
              errorMessage = error.message;
            }
            
            alert(errorMessage);
          } finally {
            this.isLoader = false;
          }
        },
      
      getCompanyUrl(companyName) {
        // המרת שם החברה ל-URL
        const companyMap = {
          'הראל': 'harel',
          'שלמה': 'shlomo',
          'מנורה': 'menora',
          'כלל': 'clal'
        };
        
        return companyMap[companyName] || companyName.toLowerCase();
      },
      
      resetResults() {
        this.insuranceResults = null;
        this.errorMessage = '';
      },
      
      closeModal() {
        let element = this.$refs.draftOrderModel
        $(element).modal('hide')
      },


       

    }
  }
  
  </script>
  
  
  